function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ad541598-f069-4770-8bea-87004c1f5716",
  "data-name": "Group 7"
}, /*#__PURE__*/React.createElement("path", {
  id: "f29270bb-d112-452d-932b-13393490bccd-172",
  "data-name": "Path 149",
  d: "M661.40034,742.552c-.111-.18415-2.77364-4.62754-3.69671-13.85434-.846-8.46459-.30232-22.73277,7.09775-42.6359,14.01854-37.70493-3.23073-68.12677-3.40659-68.42967l.851-.49371a75.598,75.598,0,0,1,7.12494,20.18435,88.05734,88.05734,0,0,1-3.64678,49.08239c-13.99413,37.64056-3.59019,55.459-3.48371,55.63485Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "fcebc901-c108-48a2-87e5-7ddb6540303c",
  "data-name": "Ellipse 19",
  cx: 439.34243,
  cy: 453.28747,
  r: 6.39325,
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "b5fd1405-e948-4f51-8090-73404e30ab37",
  "data-name": "Ellipse 20",
  cx: 459.50514,
  cy: 476.89228,
  r: 6.39325,
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "ac970879-223f-419f-9066-0afbab83f669",
  "data-name": "Ellipse 21",
  cx: 445.73511,
  cy: 492.62939,
  r: 6.39325,
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "a05fe744-c6b8-499a-b570-83da982f4ab7",
  "data-name": "Ellipse 22",
  cx: 462.45576,
  cy: 505.90737,
  r: 6.39325,
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "aa7e6742-c9e7-4b11-83e1-b132a19c1cd6",
  "data-name": "Ellipse 23",
  cx: 440.81745,
  cy: 526.5616,
  r: 6.39325,
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "b97b0dec-9dc3-4d20-978e-1db07813fbb6-173",
  "data-name": "Path 150",
  d: "M665.26235,742.785s-6.39326-15.73654,12.786-27.53952Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "adf0fd01-34d6-447b-82cb-31f3ba0f5028-174",
  "data-name": "Path 151",
  d: "M657.40074,742.50207s-2.90955-16.7345-25.42878-16.59138Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#f2f2f2"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "ab4f3350-d584-452d-9eac-b0b73bd1c74e-175",
  "data-name": "Path 140",
  d: "M326.07167,277.457a25.846,25.846,0,1,1,25.846-25.846,25.846,25.846,0,0,1-25.846,25.846Zm0-50.8a24.955,24.955,0,1,0,24.955,24.955,24.95493,24.95493,0,0,0-24.955-24.955Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#3f3d56"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "b38c2432-9b55-44a1-a6c5-37f262cb8526-176",
  "data-name": "Path 174",
  d: "M588.07166,277.457a25.846,25.846,0,1,1,25.846-25.846,25.846,25.846,0,0,1-25.846,25.846Zm0-50.8a24.955,24.955,0,1,0,24.955,24.955,24.95493,24.95493,0,0,0-24.955-24.955Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#3f3d56"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "b9a1c0cd-2b1d-41a9-871b-afddc5e936af-177",
  "data-name": "Path 146",
  d: "M682.70161,217.47h-450.245c-8.765.015-15.868,8.79-15.88,19.62V451.747c.012,10.829,7.115,19.6,15.88,19.62h450.245c8.765-.015,15.868-8.79,15.88-19.62V237.089c-.012-10.829-7.115-19.6-15.88-19.62Zm14.014,234.277c-.01,9.556-6.277,17.3-14.012,17.311h-450.247c-7.735-.012-14-7.755-14.012-17.311V237.089c.009-9.556,6.277-17.3,14.012-17.311h450.245c7.735.012,14,7.755,14.012,17.311Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#3f3d56"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "a89ccb60-c26f-4785-b3c5-3332740adbf1",
  "data-name": "Rectangle 21",
  x: 33,
  y: 148.06801,
  width: 80,
  height: 56,
  fill: "#f2f2f2"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "b7e05322-8b5b-4202-896a-d010557e20ee",
  "data-name": "Rectangle 30",
  x: 145,
  y: 148.06801,
  width: 80,
  height: 56,
  fill: "#f2f2f2"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  id: "ad37576e-0400-4032-9a23-fea9f12fbce1",
  "data-name": "Rectangle 31",
  x: 257,
  y: 148.06801,
  width: 80,
  height: 56,
  fill: "#f2f2f2"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "aa533c7f-257d-4f82-9a34-f3791ed05f8e",
  "data-name": "Rectangle 32",
  x: 369,
  y: 148.06801,
  width: 80,
  height: 56,
  fill: "#f2f2f2"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  id: "ab695b59-e86b-4a87-812a-08bf740c05b4",
  "data-name": "Rectangle 33",
  x: 33,
  y: 230.06801,
  width: 80,
  height: 56,
  fill: "#f2f2f2"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  id: "a6c88313-aaf4-41f2-8928-a742f49a0902",
  "data-name": "Rectangle 34",
  x: 145,
  y: 230.06801,
  width: 80,
  height: 56,
  fill: "#f2f2f2"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  id: "f58c3339-a4c0-4d62-ba2a-e54ff2bf716d",
  "data-name": "Rectangle 35",
  x: 257,
  y: 230.06801,
  width: 80,
  height: 56,
  fill: "#f2f2f2"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  id: "a422fb6a-8004-41fc-ab64-b502da5703c1",
  "data-name": "Rectangle 36",
  x: 369,
  y: 230.06801,
  width: 80,
  height: 56,
  fill: "#f2f2f2"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "e86106fc-25bd-447d-bb7e-e20bb3b23e30-178",
  "data-name": "Path 168",
  d: "M388.22563,441.48l-18.885-26.081,5.144-3.724,14.456,19.963,55.317-56.832,4.55,4.43Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#536dfe"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "aa2d9f48-069a-485a-b75e-c70dd332b5e8-179",
  "data-name": "Path 176",
  d: "M501.22563,359.48l-18.885-26.081,5.144-3.724,14.456,19.963,55.317-56.832,4.55,4.43Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#536dfe"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  id: "a17708df-8f3a-464e-8619-6278c337a09b",
  "data-name": "Rectangle 38",
  x: 108.46899,
  width: 1.367,
  height: 95.99,
  fill: "#2f2e41"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  id: "e9aa34a1-352e-42c8-a0fd-7deef0e48a7e",
  "data-name": "Rectangle 40",
  x: 371.46899,
  width: 1.367,
  height: 95.99,
  fill: "#2f2e41"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "fc392f67-ef8a-4310-beff-ce5a3a27e5fb-180",
  "data-name": "Path 88",
  d: "M981.95767,744.259h-379.251a1.375,1.375,0,1,1,0-2.744h379.251a1.375,1.375,0,1,1,0,2.744Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#3f3d56"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "ba3ff805-5da2-4d08-bd39-7111d50a55d9-181",
  "data-name": "Path 238",
  d: "M277.22563,359.48l-18.885-26.081,5.144-3.724,14.456,19.963,55.317-56.832,4.55,4.43Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#536dfe"
});

var _ref20 = /*#__PURE__*/React.createElement("g", {
  id: "b4e7e83f-48c8-42d0-a802-1200052d292a",
  "data-name": "Group 8"
}, /*#__PURE__*/React.createElement("path", {
  id: "bdecccf6-f579-4d39-b60a-bacda51b23df-182",
  "data-name": "Path 200",
  d: "M872.82565,528.524a10.5306,10.5306,0,0,1,1.621-.347l21.9-44.5-6.686-10.023,13.807-12.067,17.357,21.24-35.351,51.448a10.49993,10.49993,0,1,1-12.648-5.751Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#ffb8b8"
}), /*#__PURE__*/React.createElement("path", {
  id: "b851710e-73ca-4439-b312-82ecd7f1d520-183",
  "data-name": "Path 201",
  d: "M910.20865,467.742a4.51279,4.51279,0,0,1-1.016.8l-22.406,12.989a4.5,4.5,0,0,1-6.1499-1.63665q-.09393-.162-.17407-.33133l-10.9-23.023a4.476,4.476,0,0,1,1.537-5.645l13.889-9.448a4.5,4.5,0,0,1,5.718.544l19.413,19.481a4.5,4.5,0,0,1,.086,6.269Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "ad151a06-cd68-422d-8460-5ec9215ef0ce-184",
  "data-name": "Path 202",
  d: "M941.66862,722.713l-11.83,3.219-18.045-44.1,17.46-4.751Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#ffb8b8"
}), /*#__PURE__*/React.createElement("path", {
  id: "a741d46f-b26c-45f0-81fb-c6a01d8961c3-185",
  "data-name": "Path 203",
  d: "M920.47242,724.84523l22.81362-6.2073,3.90742,14.3609L910.01511,743.1146a14.887,14.887,0,0,1,10.45625-18.27326h.00006Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  id: "b643b79b-b2db-4e0a-a6b9-2a26cd7af685-186",
  "data-name": "Path 204",
  d: "M840.53764,731.74h-12.261l-5.833-47.288h18.094Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#ffb8b8"
}), /*#__PURE__*/React.createElement("path", {
  id: "a8551279-f8d8-4e53-ac0b-f4d7d43df3e0-187",
  "data-name": "Path 205",
  d: "M819.52061,728.236h23.644v14.888H804.63365a14.887,14.887,0,0,1,14.886-14.888Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("circle", {
  id: "ffb0ed30-f7ca-4f01-bb29-dfb3f0108b7e",
  "data-name": "Ellipse 33",
  cx: 636.87802,
  cy: 245.451,
  r: 24.561,
  fill: "#ffb8b8"
}), /*#__PURE__*/React.createElement("path", {
  id: "fe8d7a91-2eb0-4840-bbb3-2ac5f6694a19-188",
  "data-name": "Path 206",
  d: "M839.78665,698.024h-16.753a4.513,4.513,0,0,1-4.5-4.223c-4.992-79.361-2.072-136.289,9.19-179.153a4.69192,4.69192,0,0,1,.182-.552l.9-2.243a4.479,4.479,0,0,1,4.179-2.829h34.452a4.493,4.493,0,0,1,3.417,1.571l4.679,5.46c.091.106.177.215.259.329,21.1,29.426,40.011,86.954,61.912,164.278a4.485,4.485,0,0,1-2.958,5.517l-18,5.762a4.524,4.524,0,0,1-5.425-2.332l-46.723-96.907a3.5,3.5,0,0,0-6.62,1.046L844.24564,694.133A4.517,4.517,0,0,1,839.78665,698.024Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  id: "ac260d39-3f12-4112-9245-19e088f5ff96-189",
  "data-name": "Path 207",
  d: "M873.64462,516.455h-.141l-41.851-1.324a4.485,4.485,0,0,1-4.329-3.954c-5.3-42.941,9.244-54.445,15.746-57.4a3.46007,3.46007,0,0,0,2.012-2.743l.563-4.5a4.48314,4.48314,0,0,1,.889-2.186c10.194-13.205,24.113-17.434,31.5-18.778a4.493,4.493,0,0,1,5.21674,3.62762q.01986.11073.03424.22238l.843,6.463a3.559,3.559,0,0,0,.713,1.691c21.259,27.792-2.424,68.827-7.388,76.771h0A4.508,4.508,0,0,1,873.64462,516.455Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "b7ced118-7cfa-4844-a3c8-435a3db4f4e2-190",
  "data-name": "Path 239",
  d: "M860.476,570.12686l-31.61854,6.0933-1.20114-6.23589,24.202-4.66485L823.729,491.16693l5.93784-2.25149Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#536dfe"
}), /*#__PURE__*/React.createElement("path", {
  id: "a52cfa20-9d3d-49ed-8bbb-6f27952576f3-191",
  "data-name": "Path 208",
  d: "M903.00766,403.954a97.7524,97.7524,0,0,0-19.505-20.42c-6.2-4.841-13.1-8.978-20.709-10.956s-16.019-1.642-22.963,2.049-14.125,11.025-14.169,18.889c-.014,2.527.629,5.945,3.117,5.508l.72.1,18.007-3.637,7.669,26.616c.539,1.87,1.262,3.961,3.037,4.758,1.672.751,3.6.043,5.3-.663.278-.116,2.668-5.482,2.668-5.482a1,1,0,0,1,1.723-.288l1.42,1.775a2,2,0,0,0,2.332.6l29.366-12.259c1.353-.565,2.865-1.3,3.257-2.715C904.64761,406.468,903.81967,405.1,903.00766,403.954Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  id: "bd21c6a3-3a01-4e11-8b47-ec36a28067e7-192",
  "data-name": "Path 211",
  d: "M869.74167,577.49a10.74294,10.74294,0,0,0,1.406-16.412l7.773-93.871-23.144,3.184-.44,91.2a10.8,10.8,0,0,0,14.4,15.9Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#ffb8b8"
}), /*#__PURE__*/React.createElement("path", {
  id: "b8799e3f-759a-46c3-9e68-c27b7b779f3b-193",
  "data-name": "Path 212",
  d: "M880.43362,480.724a4.51269,4.51269,0,0,1-1.28-.185l-24.846-7.308a4.5,4.5,0,0,1-3.04737-5.58692q.05283-.17949.12036-.35409l9.195-23.754a4.476,4.476,0,0,1,5.153-2.772l16.415,3.568a4.5,4.5,0,0,1,3.542,4.521l-.764,27.492a4.5,4.5,0,0,1-4.488,4.378Z",
  transform: "translate(-216.57664 -155.73799)",
  fill: "#ccc"
}));

const SvgUndrawBookedReVtod = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 766.84671,
    height: 488.52402,
    viewBox: "0 0 766.84671 588.52402",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUndrawBookedReVtod, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/undraw_booked_re_vtod.66f955ed.svg";
export { ForwardRef as ReactComponent };